import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { loadToken } from './store/authSlice';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import VirtualSigns from './pages/VirtualSigns';
import Alerts from './pages/Alerts';
import VehicleDetail from './pages/VehicleDetail';
import SOSManagement from './pages/SOSManagement';
import SignTypes from './pages/SignTypes';
import Infractions from './pages/Infractions';

export default function App() {
  const dispatch = useDispatch();
  const { token } = useSelector((s) => s.auth);

  useEffect(() => {
    dispatch(loadToken());
  }, [dispatch]);

  if (!token) return <Login />;

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/signs" element={<VirtualSigns />} />
        <Route path="/sign-types" element={<SignTypes />} />
        <Route path="/alerts" element={<Alerts />} />
        <Route path="/infractions" element={<Infractions />} />
        <Route path="/sos" element={<SOSManagement />} />
        <Route path="/vehicle/:id" element={<VehicleDetail />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Layout>
  );
}
